// @ts-strict-ignore
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { MenuItem } from 'primeng/api';
@Component({
    selector: 'app-menu-dropdown',
    templateUrl: './menu-dropdown.component.html',
    styleUrls: ['./menu-dropdown.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class MenuDropdownComponent<T extends MenuItem> {
  @Input() icon: string = 'pi pi-ellipsis-h';
  @Input() items: any[];
  @Input() label: string;
}
